import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CompanyService }      from '../companies/company.service';
import { CustomerModel }      from '../customers/models/customer';
import { SelectOption }        from '../core/models/select-option';
import { SessionCompanyModel } from '../sessions/models/session.company';
import { SessionService }      from '../sessions/session.service';
import { VehicleModel }        from './models/vehicle';

@Component({
  selector   : 'wor-vehicle-form-default',
  template: require('./vehicle.form-default.component.html')
})
export class VehicleFormDefaultComponent {
  @Input() vehicle: VehicleModel;
  @Input() company: SessionCompanyModel;
  @Input() customer: CustomerModel;
  @Input() states: SelectOption[];
  @Input() body_types: SelectOption[];
  @Input() body_types_limited: SelectOption[];
  @Input() transmission_types: SelectOption[];
  @Input() fuel_types: SelectOption[];
  @Input() drive_types: SelectOption[];
  @Input() trackingCategoryOptions: any[];
  @Input() regoLabel: string;
  @Input() vinLabel: string;
  @Input() fleetCodeLabel: string;
  @Input() distanceLabel: string;
  @Input() plateDuplicate: boolean;
  @Input() vinDuplicate: boolean;

  @Output() onCheckPlate   = new EventEmitter<void>();
  @Output() onDelete       = new EventEmitter<void>();
  @Output() onArchive      = new EventEmitter<void>();
  @Output() onSearchRegistration = new EventEmitter<void>();
  @Output() onSetTrackingCategory = new EventEmitter<void>();

  constructor(
    public companyService: CompanyService,
    public sessionService: SessionService
  ) {}

  isPlateNumberSearchAvailable (): boolean {


    return !this.companyService.isDealer()
      && (this.companyService.hasIntegration('dvla-lookup')
        || this.companyService.hasIntegration('vehicle-registrations')
        || this.companyService.hasIntegration('carfax')
      );


  }

  canUnarchiveVehicle (): boolean {


    return this.vehicle.id
      && this.vehicle.archived
      && !this.customer.archived;


  }
}
